import React from 'react'

interface SkeletonBlockProps { height?: string | number; width?: string; borderRadius?: string; style?: React.CSSProperties; delay?: number }

export const SkeletonBlock: React.FC<SkeletonBlockProps> = ({ height = '16px', width = '100%', borderRadius = '4px', delay = 0, style }) => (
  <>
    <style>{`@keyframes skeletonShimmer { 0% { background-position: 200% 0 } 100% { background-position: -200% 0 } }`}</style>
    <div style={{ height, width, borderRadius, background: 'var(--bg-elevated)', backgroundImage: 'linear-gradient(90deg, var(--bg-elevated) 25%, var(--bg-sidebar) 50%, var(--bg-elevated) 75%)', backgroundSize: '200% 100%', animation: `skeletonShimmer 1.5s ${delay}s infinite`, ...style }} />
  </>
)
